import { Helmet } from "react-helmet";

const MetaData = ({ title }) => {
  return (
    <Helmet>
      <title>{`${title} | Impero Techne`}</title>
    </Helmet>
  );
};

export default MetaData;
